import React from 'react'

import logoFacebook from '../assests/images/handelbay_logo_facebook.svg';
import logoInstagram from '../assests/images/handelbay_logo_instagram.svg';
import logoYoutube from '../assests/images/handelbay_logo_youtube.svg';
import logoLinkedin from '../assests/images/handelbay_logo_linkedin.svg';

export default (props) => {
  return(
    <>
      <div className="footer-container-logos">
				<a href="https://handelbay.com.co">
					<img src={logoFacebook} alt="logoFacebook" height="30px" />
				</a>
				<a href="https://handelbay.com.co">
					<img src={logoInstagram} alt="logo instagram" height="30px" />
				</a>
				<a href="https://handelbay.com.co">
					<img src={logoYoutube} alt="logo Youtube" height="30px" />
				</a>
				<a href="https://handelbay.com.co">
					<img src={logoLinkedin} alt="logo Linkedin" height="30px" />
				</a>
			</div>
			<p className="text-footer">2019 &copy; Todos los derechos reservados - Ignite Technologies S.A.S</p>
    </>
  )
}